import reducer from 'state/mrCollection/shipments/reducer';
import selectors from 'state/mrCollection/shipments/selectors';
import actions from 'state/mrCollection/shipments/actionCreators';
import effects from 'state/mrCollection/shipments/effects';

export { selectors, actions, effects };
export default reducer;
